export const GLOBAL_AGENT_NET_TYPES_RESET_STATE = 'GLOBAL_AGENT_NET_TYPES_RESET_STATE';
export const GLOBAL_AGENT_NET_TYPES_CURRENT_ITEM = 'GLOBAL_AGENT_NET_TYPES_CURRENT_ITEM';

export const GLOBAL_AGENT_NET_TYPES_REQUEST_LOADING = 'GLOBAL_AGENT_NET_TYPES_REQUEST_LOADING';
export const GLOBAL_AGENT_NET_TYPES_REQUEST_SUCCESS = 'GLOBAL_AGENT_NET_TYPES_REQUEST_SUCCESS';
export const GLOBAL_AGENT_NET_TYPES_REQUEST_FAILED = 'GLOBAL_AGENT_NET_TYPES_REQUEST_FAILED';

export const GLOBAL_AGENT_NET_TYPES_CURRENT_ACTION = 'GLOBAL_AGENT_NET_TYPES_CURRENT_ACTION';
export const GLOBAL_AGENT_NET_TYPES_RESET_ACTION = 'GLOBAL_AGENT_NET_TYPES_RESET_ACTION';